<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M12 12V5H4v7h8zm-2-6v1H6V6h4zm4 8H2V5H1V3h14v2h-1v9z" :fill="color" fill-rule="evenodd"/></svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#363a5e'
    }
  }
}
</script>
